import { useMutation } from "@tanstack/react-query";
import { api } from "./utils/api-base";
import { ActivityLog, ActivityLog_Kind } from "~/shared/types/activity_log";

export const useCreateActivityLog = () => {
  return useMutation({
    mutationFn: async (activity_log: {
      kind: ActivityLog['kind'],
      data?: ActivityLog['data']
      info?: ActivityLog['info'],
      resource_type?: ActivityLog['resource_type'],
      resource_id?: ActivityLog['resource_id'],
    }) => {
      const response = await api.post<ActivityLog>('/activity_logs', { activity_log });
      return response.data;
    },
  });
};

export const useUpdateActivityLog = () => {
  return useMutation({
    mutationFn: async ({ id, activity_log }: {
      id: number,
      activity_log: {
        position?: number,
      },
    }) => {
      const response = await api.put<ActivityLog>(`/activity_logs/${id}`, { activity_log });
      return response.data;
    },
  });
};

export const useDestroyActivityLog = () => {
  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      await api.delete(`/activity_logs/${id}`);
    },
  });
};
